<template>
  <div class="spinner" v-if="isVisible">
    <i class="icon-spinner" />
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    showAfter: { type: Number, default: 3000 },
  },
  data: () => ({
    isVisible: false,
    timerId: 0,
  }),
  created() {
    this.timerId = setTimeout(() => this.isVisible = true, this.showAfter);
  },
  beforeUnmount() {
    clearTimeout(this.timerId);
  },
};
</script>
